import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import Buefy from 'buefy';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import VueGallery from 'vue-gallery';
import vueCustomElement from 'vue-custom-element';
// @ts-ignore
import VueLuxon from 'vue-luxon';
// @ts-ignore
import vueNumeralFilterInstaller from 'vue-numeral-filter';

// import polyfill for older browser support
import 'document-register-element/build/document-register-element';

// store the app in a variable to prevent typescript from giving errors
const VueApp: any = App;

Vue.component('vue-fontawesome', FontAwesomeIcon);
Vue.component('vue-gallery', VueGallery);

Vue.config.productionTip = false;

Vue.use(Buefy, { defaultIconComponent: 'vue-fontawesome' });
Vue.use(VueLuxon, {
  input: 'server',
  output: {
    zone: 'Europe/Amsterdam',
    format: 'med',
    locale: 'nl'
  }
});
Vue.use(vueNumeralFilterInstaller, { locale: 'nl-NL' });

// Vue.use(VueNumerals); // default locale is 'en'
Vue.use(vueCustomElement);

// register it as a custom element
VueApp.store = store;
router();
Vue.customElement('pew-widget', VueApp);
